import { render } from "./UnsavedChangesDialog.vue?vue&type=template&id=f8db6bdc&ts=true"
import script from "./UnsavedChangesDialog.vue?vue&type=script&lang=ts"
export * from "./UnsavedChangesDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__